import React from "react";
import { useLocalStorageState } from "ahooks";

import { Checkbox, Layout, ShowBoat } from "lib/components";
import { CharsetKey, charsetWithLabels, useGeneratedPassword } from "lib";

import "./App.scss";

function App() {
  const [sets, setSets] = useLocalStorageState<CharsetKey[]>(
    "password-bam-selected-chars",
    { defaultValue: ["uc", "lc", "n", "s"] }
  );
  const [length, setLength] = useLocalStorageState<number>(
    "password-bam-selected-length",
    { defaultValue: 16 }
  );
  const password = useGeneratedPassword({ chars: sets, length: length });

  const toggleSet = (set: CharsetKey) => {
    if (sets.includes(set)) {
      const newSet = sets.slice();
      newSet.splice(sets.indexOf(set), 1);
      setSets(newSet);
    } else {
      setSets([...sets, set]);
    }
  };

  return (
    <Layout>
      <h2 className="text-center">Make a password:</h2>
      <ShowBoat text={password} />
      <div className="options">
        <h3>Options</h3>
        <div className="options-characters">
          {Object.entries(charsetWithLabels).map(([key, label]) => (
            <Checkbox
              key={key}
              label={label}
              onChange={() => toggleSet(key as CharsetKey)}
              checked={sets.includes(key as CharsetKey)}
            />
          ))}
        </div>
        <div className="options-length">
          <div className="form-item">
            <label
              htmlFor="options-length"
              style={{ display: "inline", marginRight: "1rem" }}
            >
              Length
            </label>
            <input
              type="number"
              className="input-text"
              min="5"
              max="64"
              step={1}
              value={length}
              onChange={(e) => setLength(Number(e.target.value))}
              size={5}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default App;
